import React from 'react';
import { DateTime } from 'luxon';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import { RouteComponentProps } from 'react-router';
import ApolloClient from 'apollo-client';
import { NormalizedCacheObject } from 'apollo-cache-inmemory';
import { MockApolloClient } from 'mock-apollo-client';

import SessionRow from './SessionRow/SessionRow';
import { FormattedCoachingVisit } from '../../../../models/Sessions';
import DayHeader from './DayHeader/DayHeader';
import SessionsListHeader from './SessionsListHeader/SessionsListHeader';

type Props = WithStyles<typeof styles> & {
  currentDateTime: DateTime;
  day: string;
  history: RouteComponentProps['history'];
  isUpcomingView: boolean;
  localTimezone: string;
  memberClient: ApolloClient<NormalizedCacheObject> | MockApolloClient;
  onVisibleMemberProfileDrawer: (Member) => void;
  refreshCurrentSessions: () => void;
  sessionsByDay: FormattedCoachingVisit[];
};

const SessionsByDay: React.FC<Props> = ({
  classes,
  currentDateTime,
  day,
  history,
  isUpcomingView,
  localTimezone,
  memberClient,
  onVisibleMemberProfileDrawer,
  refreshCurrentSessions,
  sessionsByDay,
}) => {
  const visits = Object.values(sessionsByDay).sort(
    (lhs: FormattedCoachingVisit, rhs: FormattedCoachingVisit) =>
      new Date(lhs.scheduledTime).getTime() - new Date(rhs.scheduledTime).getTime(),
  );

  return (
    <div key={`${currentDateTime.month}_${day}`} className={classes.sessionDay}>
      <DayHeader currentDateTime={currentDateTime} day={day} localTimezone={localTimezone} />

      <div className={classes.sessionList}>
        <SessionsListHeader />

        <div>
          {visits.map(
            (visit) =>
              visit && (
                <SessionRow
                  isUpcomingView={isUpcomingView}
                  key={visit.uuid}
                  memberClient={memberClient}
                  onJoinSession={() => history.push(`/video-session/${visit.uuid}`)}
                  onSuccessfulCancel={refreshCurrentSessions}
                  onUpdateVisit={refreshCurrentSessions}
                  onVisibleMemberProfileDrawer={onVisibleMemberProfileDrawer}
                  visit={{
                    ...visit,
                    scheduledDateTime: DateTime.fromISO(visit.scheduledTime),
                  }}
                />
              ),
          )}
        </div>
      </div>
    </div>
  );
};

const styles = () =>
  createStyles({
    sessionDay: {
      display: 'flex',
      flex: 0,
      flexDirection: 'column',
      marginTop: 30,
    },
    sessionList: {
      display: 'flex',
      flexDirection: 'column',
    },
  });

export default withStyles(styles)(SessionsByDay);
